export enum ProtocolTypeEnum {
  MODBUS_RTU = "MODBUS_RTU",
  MODBUS_TCP = "MODBUS_TCP",
  SIEMENS_S7 = "SIEMENS_S7"
}
